module.exports = __webpack_public_path__ + "Participant Notice 07_31_2024.pdf";